import React, { useState, useContext, useEffect, useRef } from "react";
import CropTool from "./CropTool";
import UploadField from "../../../../UX/UploadField/UploadField";
import { FileUploadContext } from "../../../../Providers/FileUploadProvider/FileUploadProvider";
import styled from "styled-components";
import FileTable from "./FileTable";

const Progress = styled.progress`
    width: 100%;
`;

const FileUploadCrop = ({ step, bleed }) => {
    const {
        files,
        uploading,
        setUploading,
        error,
        setError,
        onUploadFiles,
        onDeleteFile,
        onDeleteCropped,
        onUploadCroppedFile,
        croppedFile
    } = useContext(FileUploadContext);

    const cropContainerRef = useRef(null);

    const [croppedImageUrl, setCroppedImageUrl] = useState(null);

    if (error) {
        return (
            <>
                <div className="w-full">
                    <div
                        style={{
                            borderRightColor: "#FEEBC8",
                            borderTopColor: "#FEEBC8",
                            borderBottomColor: "#FEEBC8"
                        }}
                        className="rounded bg-orange-100 border-l-4 border-orange-500 text-orange-700 border p-4 "
                        role="alert">
                        <p className="font-bold mb-1">
                            Er is iets misgegaan met uploaden
                        </p>
                        {error.map(e => (
                            <p className="mb-1" key={e.id}>
                                {e.message}
                            </p>
                        ))}
                        <p>
                            Je kunt je bestand ook aanleveren via{" "}
                            <a
                                href="https://24drukwerk.wetransfer.com/"
                                target="_Blank"
                            >
                                <u>WeTransfer</u>
                            </a>
                        </p>
                        <button onClick={() => {
                            setError(false);
                            setUploading(false);
                        }} className="bg-blue-500 text-white px-4 py-2 text-white rounded mt-4 font-bold hover:bg-blue-600 text-sm">Opnieuw uploaden</button>
                    </div>
                </div>
            </>
        );
    }

    if (uploading) {
        return (
            <>
                <div className="cell large-12 justify-center">
                    <h4>De bestanden worden geüpload, moment geduld</h4>
                </div>
                <div className="cell large-12">
                    <Progress className="success" max="100" value={uploading} />
                </div>
            </>
        );
    }

    if (croppedFile) {
        return (
            <>
                <div className="cell large-12">
                    <FileTable
                        files={[croppedFile]}
                        onDeleteFile={onDeleteCropped}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            {files.length > 0 ? (
                <>
                    <div ref={cropContainerRef} className="w-full mb-2">
                        <CropTool
                            containerRef={cropContainerRef}
                            bleed={bleed}
                            croppedImageUrl={croppedImageUrl}
                            setCroppedImageUrl={setCroppedImageUrl}
                            step={step}
                            files={files}
                        />
                    </div>
                    <div className="w-full">
                        <button
                            onClick={() =>
                                onUploadCroppedFile(
                                    croppedImageUrl,
                                    files[0].name
                                )
                            }
                            className="bg-blue-500 text-white px-4 py-2 text-white rounded mr-2 font-bold hover:bg-blue-600 text-sm mr-2  mb-4"
                        >
                            Gebruik uitsnede
                        </button>

                        <button
                            onClick={() => onDeleteFile(files[0].value)}
                            className="bg-blue-500 text-white px-4 py-2 text-white rounded mr-2 font-bold hover:bg-blue-600 text-sm mb-4"
                        >
                            Verwijder bestand
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className="w-full">
                        <UploadField
                            scale={600}
                            multiple={false}
                            onFileDrop={onUploadFiles}
                            className="w-full"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default FileUploadCrop;
